export default __webpack_public_path__ + "static/port5-fd5ee1192da2873cfbb407203c22471b.jpg";